import * as React from "react";
import classnames from "classnames";
import { useIntl } from "@grandvisionhq/state";
import Link from "../../Link/Link/Link.js";
import LinkLists from "../../LinkLists/LinkLists/LinkLists.js";
/* empty css                       */
const SpotlightedStores = ({ className, items, storesUrl, ...rest }) => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement("div", { className: classnames("spotlighted-stores", className), ...rest }, /* @__PURE__ */ React.createElement("div", { className: "site-container" }, /* @__PURE__ */ React.createElement(LinkLists, { items }), /* @__PURE__ */ React.createElement(
    Link,
    {
      className: "spotlighted-stores__link",
      label: getLabel("common.component.spotlightedStores.link"),
      url: storesUrl,
      openInNewWindow: false
    }
  )));
};
export {
  SpotlightedStores as default
};
//# sourceMappingURL=SpotlightedStores.js.map
